import { photoFilterCss } from "@/lib/filters"

type BlackPhotoProps = {
  src?: string
  alt?: string
  filter?: string
  brightness?: number
  contrast?: number
  saturate?: number
  fit?: "contain" | "cover"
  className?: string
}

export default function BlackPhoto({
  src,
  alt = "Photo",
  filter = "normal",
  brightness = 100,
  contrast = 100,
  saturate = 100,
  fit = "contain",
  className = "",
}: BlackPhotoProps) {
  const css = photoFilterCss(filter, brightness, contrast, saturate)
  const objectFit = fit === "cover" ? "object-cover" : "object-contain"

  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={`h-full w-full ${objectFit} ${className}`}
        style={{ filter: css }}
      />
    )
  }

  return (
    <div
      className={`relative h-full w-full overflow-hidden bg-black ${className}`}
      style={{ filter: css }}
      aria-label={alt}
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,#1a1a1a,transparent_42%),linear-gradient(180deg,#0a0a0a,#000)]" />
      <div className="absolute inset-0 opacity-40 [background-image:linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] [background-size:28px_28px]" />
    </div>
  )
}
